import { NotificationService, LoaderService, CONSTANT, EVENTO, TOOLTIPS, ICONS, ACTIONS } from "../../../../shared/session/index";
import { CustomValidators, RegularExpression, RegularExpressionMessage } from '../../../../shared/validation/customvalidation';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Module, Imodule } from "../shared/module.model";
import { Aplicacion } from '../../Aplicaciones/shared/aplicacion.model'
import { ModuleService } from "../shared/module.service";
import { AplicacionService } from "../../Aplicaciones/shared/aplicacion.service";

@Component({
  //moduleId: module.id,
  selector: 'app-module-new',
  templateUrl: 'module-new.component.html'
})
export class ModuleNewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any
  @Input() titlePage: string;

  formGroupNewModule: FormGroup;
  msgSuccessInsert: string;
  msgErrorInsert: string;
  obligatorioMsg: string;
  modules: Imodule;
  maxLengthMsg: string;
  pathMaxLength: number;
  nomAccessMaxLength: number;
  descripcionMaxLength: number;
  nomAccessPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  buttonGroup: any;
  nomPathMaxLength: number;
  msgErrorGetAplicaciones: string;

  // Combos
  aplicaciones: Aplicacion[];

  constructor(
    private loaderService: LoaderService,
    private moduleService: ModuleService,
    private notificationService: NotificationService,
    private aplicacionService: AplicacionService,
    public fb: FormBuilder
  ) { }

  ngOnInit() {
    this.modules = new Module(0, "", 1, "", true,"", "","", "", "");
    this.msgSuccessInsert = 'Se registró satisfactoriamente';
    this.msgErrorInsert = 'Error al registrar el Modulo';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.maxLengthMsg = 'El tamaño máximo es de ';
    this.msgErrorGetAplicaciones = "Error al listar los Modulos";
    this.nomPathMaxLength = 100;
    this.nomAccessMaxLength = 100;
    this.descripcionMaxLength = 250;
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.setValuesFormBuilder();
    this.listarAplicacionCbo();
  }
  private setValuesFormBuilder() {
    this.formGroupNewModule = this.fb.group({
      moduleName: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomAccessMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      descripcion: ['', Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      aplicacionID: [this.modules.AplicacionID]
    });
  }

  changeEvent(modules: Imodule) {
    this.data.modules = { ID: modules.ModuleID, Name: modules.Name };
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  formGroupNewModuleSubmit(event) {
    if (this.formGroupNewModule.invalid)
      return;
    this.modules.Name = event.value.moduleName;
    this.modules.Descripcion = event.value.descripcion;
    this.modules.AplicacionID = event.value.aplicacionID;

    this.insertarModule(this.modules);
  }

  private insertarModule(modules: Imodule) {
    this.loaderService.show();
    this.modules.Status = CONSTANT.estadoRegistro.activo;
    this.moduleService.insertarModule(modules)
    .subscribe(res => {
      modules.ModuleID = res;
      this.changeEvent(modules);
      this.notificationService.successful("Se grabó satisfactoriamente");
    },
    error => {
      this.notificationService.error(this.msgErrorInsert);
      throw error;
    },
    () => {
      this.loaderService.hide();
    });
  }

  private listarAplicacionCbo(): void {
    this.loaderService.show();
    this.aplicacionService.listarApplication()
    .subscribe(res => {
      this.aplicaciones = res;
    },
    error => {
      this.notificationService.error(this.msgErrorGetAplicaciones);
      throw error;
    },
    () => {
      this.loaderService.hide();
    });
  }
}
